import React, { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";

import PropTypes from "prop-types";
import urlParams from "@assets/js/url-params";
import {
  CONFIGURATOR_TYPE,
  CONFIGURATOR_SELECTOR
} from "@constants";
import usePDPStore, {
  useActiveConfigurationSKU,
  useActiveProductData,
  useConfigurationType,
  useActiveSelector,
  parseExistingHeroSelectionDisplayName
} from "@store/pdp";
import { PlusSvg } from "@assets/js/icons";
import { log } from "@assets/js/utils";

import "./pdp-hero-selection.scss";

const PDPHeroSelection = () => {
  const [activeProductData] = useActiveProductData();
  const setActiveProductHeroDisplayName = usePDPStore((state) => state.setActiveProductHeroDisplayName);
  const [activeConfigurationSKU,] = useActiveConfigurationSKU();
  const [configurationType, setConfigurationType] = useConfigurationType();
  const [, setActiveSelector] = useActiveSelector();
  const [activeIndex, setActiveIndex] = useState(-1);
  const { t } = useTranslation();

  const texts = {
    choose: t(
      "FritzHansen_Project_ConsumersAndProfessionals_PDP_Choose"
    ),
    chooseWithNoConfigurator: t(
      "FritzHansen_Project_ConsumersAndProfessionals_PDP_ChooseWithNoConfigurator"
    ),
    designConfigurationButton: t(
      "FritzHansen_Project_ConsumersAndProfessionals_PDP_DesignConfigurationButton"
    ),
  };

  const getActiveItem = useCallback(() => {

    if (activeConfigurationSKU && activeProductData?.heroselectionIds?.includes(activeConfigurationSKU)) {
      let activeConfigurationSKUWithoutOptions = activeConfigurationSKU.split('_')[0];
      var newIndex = activeProductData?.heroselectionIds?.indexOf(activeConfigurationSKUWithoutOptions);
      return activeProductData?.heroselectionsIdsDisplayName[newIndex]?.split("|")[1];
    }
    return null;
  }, [activeConfigurationSKU]);

  useEffect(() => {
    if (activeConfigurationSKU) {
      //heroselections can be with or without options. Check both.
      var newIndex = activeProductData?.heroselectionIds?.indexOf(activeConfigurationSKU);
      if (newIndex == -1) {
        let activeConfigurationSKUWithoutOptions = activeConfigurationSKU.split('_')[0];
        newIndex = activeProductData?.heroselectionIds?.indexOf(activeConfigurationSKUWithoutOptions);
      }
      if (newIndex > -1) {
        setActiveIndex(newIndex);
      } else {
        setActiveIndex(-1)
      }
    }
  }, [activeConfigurationSKU, getActiveItem]);

  const openConfiguratorHandler = () => {
    setActiveSelector(CONFIGURATOR_SELECTOR.OVERVIEW);
  }

  const clickHandler = (skuString) => {
    urlParams.set({ sku: skuString });
    
    let configurationTypeIdValue = skuString.split("-")[0];
    let skuParams = urlParams.getSKU();
    if (configurationType?.type?.value === CONFIGURATOR_TYPE.VARIATION_GROUP) {
      configurationTypeIdValue = skuParams.variationGroupId;
    }
  
    setConfigurationType({
      id: { value: configurationTypeIdValue },
      type: { value: configurationType.type.value },
    });
  };

  return (
    <>
      <div className="pdp-micro-swatches choose-configuration">
        <h4>{activeProductData?.heroselectionsIdsDisplayName?.length > 0 && (!activeProductData.hideConfiguratorButton ? texts.choose : texts.chooseWithNoConfigurator)}</h4>
        <div className="pdp-micro-swatches__list">
          <div className="pdp-micro-swatches__list__inner hero-selection">
            {activeProductData?.heroselectionsIdsDisplayName?.length > 0 && activeProductData?.heroselectionsIdsDisplayName.map((item, index) => {
              
              const skuStr = item?.split("|")[0];
              const imageSkuStr = skuStr?.split("_")[0];
              const imageUrl = activeProductData?.heroSelectionsIdsWithImageUrl?.find(i => i.split("|")[0] == skuStr)?.split("|")[1];
              
              return (
                <button
                  onMouseEnter={() => { setActiveProductHeroDisplayName(item.split("|")[1] ?? null) }}
                  onMouseLeave={() => { setActiveProductHeroDisplayName(parseExistingHeroSelectionDisplayName(activeProductData, activeConfigurationSKU)) }}
                  onClick={() => clickHandler(skuStr)}
                  to={`?sku=${skuStr}`}
                  key={`swatch${index}${skuStr}`}
                  className={`pdp-hero-selection__list-item ${index === activeIndex ? "is-active" : ""
                    }`}
                >
                  <div>
                    <img src={imageUrl ? imageUrl : process.env.REACT_APP_PRODUCT_IMAGE_API + "/r/" + imageSkuStr + "-r2.webp?sw=80&trim=true&bgcolor=efeeeb"} alt="" />
                  </div>
                </button>
              );
            })}
            {!activeProductData.hideConfiguratorButton &&
              <button onClick={openConfiguratorHandler} className="pdp-hero-selection__list-item open-configurator-item">
                <div className="open-configurator-item__inner">
                  <PlusSvg width={23} height={23} />
                </div>
              </button>}
          </div>
        </div>
      </div>
    </>
  );
};
PDPHeroSelection.propTypes = {
  options: PropTypes.array,
};

export default PDPHeroSelection;
